import type { AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";
import type { SessionView } from "shared/mappers/database/session/session";
import type { DeviceInfo } from "hub/src/utils/getDeviceInfo";
import { hasRouteAccess } from "hub/src/utils/routes/hasRouteAccess";
import { isCurrentPlatformRoute } from "hub/src/utils/routes/isCurentPlatformRoute";

type IsRouteVisibleParams = {
  device?: DeviceInfo;
  session?: Partial<SessionView> | null;
  route?: Partial<AppRouteConfigView>;
};

export const isRouteVisible = ({
  device,
  session,
  route,
}: IsRouteVisibleParams): boolean => {
  return (
    isCurrentPlatformRoute({ device, route }) &&
    hasRouteAccess({ session, route })
  );
};
